import BlogNewsletter from "../components/blog-newsletter";
import { NavSlider, NavSliderItem } from "../components/nav-slider";

export default {
	name: 'Glossary',
	components: {
		BlogNewsletter,
		NavSlider,
		NavSliderItem,
	},
};
